import "@assets/style/global.css";
import gift_icon from "@images/gift_icon.png";
import { Outlet } from "react-router-dom";
import { Suspense, useState, useEffect, useCallback } from "react";
import { TaleLoadingFallback } from "@components/TaleLoadingFallback";
import { useSelector } from "react-redux";
import authService from "@services/auth";

const AwardsLayout = () => {
    const { user } = useSelector((state) => state.auth);
    const [totalPoints, setTotalPoints] = useState(user?.totalPoints || 0);

    const refreshPoints = useCallback(async () => {
        try {
            const freshUser = await authService.getCurrentUserLocal();
            if (freshUser?.totalPoints !== undefined) {
                setTotalPoints(freshUser.totalPoints);
            }
        } catch (err) {
            console.error("Failed to refresh points:", err);
        }
    }, []);

    useEffect(() => {
        refreshPoints();
    }, [refreshPoints]);

    return (
        <div className="flex flex-col gap-3">
            <div
                className="w-full rounded-2xl flex py-6 px-11 justify-between items-center"
                style={{
                    background:
                        "linear-gradient(90.33deg, #FFD451 2.25%, #FFDCBC 47.64%, #FFD7A6 99.87%)",
                }}
            >
                <div className="flex flex-col gap-1">
                    <span className="text-[32px] font-extrabold font-sans">
                        {totalPoints.toLocaleString()} Points
                    </span>
                    <span className="text-sm !max-w-[505px] text-wrap font-medium">
                        Explore our world of rewards! Exchange your points for exclusive gifts and discover a myriad of options that will delight you
                    </span>
                </div>
                <img
                    src={gift_icon}
                    alt="Gift Icon"
                    style={{ width: "174px", height: "150px" }}
                />
            </div>

            <div className="flex flex-col w-full bg-white p-6 rounded-2xl gap-6">
                <Suspense fallback={<TaleLoadingFallback className="py-20" />}>
                    <Outlet context={{ refreshPoints }} />
                </Suspense>
            </div>
        </div>
    );
};

export default AwardsLayout;
